/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FlatShow, SlideShow } from './imageSlideshow';
import {
  mainBannerImage,
  mainBannerProperties,
  newBook,
  newbookProperties,
  newbookTabletProperties,
  newbookMobileProperties,
} from './BannerImageList';

import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function Main(routeProps: RouteComponentProps) {
  // const [boardData = [], setBoardData] = useState<any>();
  const [noticeList, setNoticeList] = useState<any[]>([]);
  const [libList, setLibList] = useState<any[]>([]);
  const [errataList, setErrataList] = useState<any[]>([]);
  const [newBookComputer, setNewBookComputer] = useState<Boolean>(false);
  const [newBookTablet, setNewBookTablet] = useState<Boolean>(false);
  const [cooperative, setCooperative] = useState<any>([]);
  const [academy, setAcademy] = useState<any>([]);
  const dispatch = useDispatch();
  const cooperativeTemp: any = [];
  const academyTemp: any = [];
  const isNew = 'Y';

  useEffect(() => {
    WindowOrMobile();
    getMainBanner().then(() => {
      getNewBooks().then(() => {
        getBoardList().then(() => {
          getBannerCompanies();
        });
      });
    });
  }, []);

  // 메인배너 조회 API 호출
  const getMainBanner = async () => {
    // await server.getBanners(1, 10).then((payload) => {
    await server
      .getAdvertisements(1, 10)
      .then((payload) => {
        for (let i = 0; i < payload.items.length; i++) {
          mainBannerImage[i].id = payload.items[i].id;
          mainBannerImage[
            i
          ].img = `${process.env.REACT_APP_API_URL}/public${payload.items[i].imageUrl}`;
          mainBannerImage[i].url = payload.items[i].siteUrl;
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    for (let i = 0; i < mainBannerImage.length; i++) {
      if (mainBannerImage[i].id === 0) {
        mainBannerImage.splice(i, 1);
        i--;
      }
    }
  };

  // 신간도서 조회 API 호출
  const getNewBooks = async () => {
    await server
      .getBookIs(1, 10, '', '', isNew, '', '', '')
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          for (let i = 0; i < payload.meta.itemCount; i++) {
            newBook[i].id = payload.items[i].id;
            newBook[i].url = `/books/${payload.items[i].id}`;
            newBook[
              i
            ].img = `${process.env.REACT_APP_API_URL}/public${payload.items[i].imageMiddleUrl}`;
            newBook[i].alt = payload.items[i].size;
            newBook[i].name = payload.items[i].name;
            newBook[i].writer = payload.items[i].author;
            newBook[i].price = `${Number(payload.items[i].price).toLocaleString()}원`;
          }
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 게시판 조회 API 호출
  const getBoardList = async () => {
    await server
      .getBoardList('notice', 1, 5)
      .then((payload) => {
        setNoticeList(payload.items);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    await server
      .getBoardList('lib', 1, 5)
      .then((payload) => {
        setLibList(payload.items);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    await server
      .getBoardList('errata', 1, 5)
      .then((payload) => {
        setErrataList(payload.items);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  const onClickItem = (boardId: any, boardCtgy: any, username: any) => {
    const i = {
      id: boardId,
      ctgy: boardCtgy,
    };

    routeProps.history.push({
      pathname: '/board/boardView', // '/board/boardView',
      search: `?${new URLSearchParams(i).toString()}`,
      state: {
        // replie: item.replieButton,
        // delete: item.deleteButton,
        // update: item.updateButton,
        userId: username,
      },
    });
  };

  const WindowOrMobile = () => {
    const width = window.innerWidth;
    if (width >= 769) {
      setNewBookComputer(true);
    }
    if (width > 549 && width < 769) {
      setNewBookTablet(true);
    }
  };

  // 협력사 및 교육기관 배너 가져오기
  const getBannerCompanies = async () => {
    await server
      .getBanners(1, 100)
      .then((payload) => {
        for (let i = 0; i < payload.items.length; i++) {
          if (payload.items[i].flag === '1') {
            cooperativeTemp.push(payload.items[i]);
          } else if (payload.items[i].flag === '2') {
            academyTemp.push(payload.items[i]);
          }
        }
        setCooperative(cooperativeTemp);
        setAcademy(academyTemp);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  return (
    <main className="wrapper main">
      <section className="slider">
        {SlideShow('main-slider', mainBannerImage, mainBannerProperties)}
      </section>
      <section className="books-new">
        <h3>신간도서</h3>
        {newBookComputer
          ? SlideShow('books-slider', newBook, newbookProperties)
          : SlideShow(
              'books-slider',
              newBook,
              newBookTablet ? newbookTabletProperties : newbookMobileProperties
            )}
      </section>
      <section className="row">
        <ul className="boards">
          <li>
            <div className="board-header">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z" />
                </svg>
                <span>공지사항</span>
              </h3>
              <Link to="/board/notice">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                </svg>
              </Link>
            </div>
            <div className="content">
              {noticeList.map((board: any) => (
                // <Link to={`/board/boardView?id=${board.id}&ctgy=${board.category}`} key={board.id}>
                <a
                  key={board.id}
                  onClick={() => {
                    onClickItem(board.id, board.category, board.writer?.username);
                  }}
                >
                  <span>{board.subject}</span>
                  <small>{new Date(board.modDate).toLocaleDateString()}</small>
                </a>
                // </Link>
              ))}
            </div>
          </li>
          <li>
            <div className="board-header">
              <h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enableBackground="new 0 0 24 24"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                >
                  <g>
                    <rect fill="none" height="24" width="24" />
                  </g>
                  <g>
                    <path d="M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z" />
                  </g>
                </svg>
                <span>자료실</span>
              </h3>
              <Link to="/board/lib">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                </svg>
              </Link>
            </div>
            <div className="content">
              {libList.map((board: any) => (
                <a
                  key={board.id}
                  onClick={() => {
                    onClickItem(board.id, board.category, board.writer?.username);
                  }}
                >
                  <span>{board.subject}</span>
                  <small>{new Date(board.modDate).toLocaleDateString()}</small>
                </a>
              ))}
            </div>
          </li>
          <li>
            <div className="board-header">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                </svg>
                <span>정오표</span>
              </h3>
              <Link to="/board/errata">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                </svg>
              </Link>
            </div>
            <div className="content">
              {errataList.map((board: any) => (
                <a
                  key={board.id}
                  onClick={() => {
                    onClickItem(board.id, board.category, board.writer?.username);
                  }}
                >
                  <span>{board.subject}</span>
                  <small>{new Date(board.modDate).toLocaleDateString()}</small>
                </a>
              ))}
            </div>
          </li>
        </ul>
        <div className="icon-menu">
          <Link to="/info/bookstore">서점안내</Link>
          {window.localStorage.getItem('token') !== null ? (
            <Link to="/board/publicationqna">출판문의</Link>
          ) : (
            <Link
              className="link-to-publishaa"
              to="/login"
              onClick={() => {
                dispatch(toast.error({ message: '로그인이 필요합니다.' }));
              }}
            >
              출판문의
            </Link>
          )}
          <Link
            className="link-to-group-buyingaa"
            to="#"
            onClick={() => {
              dispatch(
                toast.info({
                  message: '공동구매를 원하시는 고객님은 당사 02)701-7421로 연락바랍니다.',
                })
              );
            }}
          >
            공동구매
          </Link>
          {/* <Link to="/order/group-buying">공동구매</Link> */}
          <Link to="/board/books-all">도서목록</Link>

          {/* <!-- 교수님 전용 --> */}
          {window.localStorage.getItem('part') === 'professor' ||
          window.localStorage.getItem('authority') === 'A' ? (
            <>
              <Link to="/professor/lecture-material">강의자료실</Link>
              <Link to="/professor/request-sample">견본도서</Link>
            </>
          ) : (
            <>
              <Link
                to="#"
                onClick={() => {
                  dispatch(toast.error({ message: '교수 회원님 전용 공간입니다.' }));
                }}
              >
                강의자료실
              </Link>
              <Link
                to="#"
                onClick={() => {
                  dispatch(toast.error({ message: '교수 회원님 전용 공간입니다.' }));
                }}
              >
                견본도서
              </Link>
            </>
          )}
        </div>
      </section>
      <section className="bookstore">
        <h3>협력사</h3>
        {FlatShow('flex-container', cooperative)}
      </section>
      <section className="bookstore">
        <h3>교육기관</h3>
        {FlatShow('flex-container', academy)}
      </section>
    </main>
  );
}
